import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

type StylesType = {
  depth: number
  isOverTop: boolean
  isOverBottom: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  drag: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '6px',
    cursor: 'grab'
  },

  emptyDrag: {
    width: '16px',
    marginRight: '8px'
  },

  drop: {
    height: '0.25rem !important'
  },

  dropTop: {
    background: ({ isOverTop }) =>
      isOverTop ? theme.palette.primary.main : 'transparent'
  },

  dropBottom: {
    background: ({ isOverBottom }) =>
      isOverBottom ? theme.palette.primary.main : 'transparent'
  },

  row: {
    cursor: 'pointer'
  },

  placeholder: {
    width: '100%',
    height: '47.5px',
    backgroundColor: 'hsl(0, 0%, 90%)'
  }
}))

export default useStyles
